import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import { getPathAcctoYear } from "../utils/functions/common";

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("flexgrade__token");
      if (token) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return <Loader />;
  }

 
  if (!isAuthenticated) {
    return <Navigate to={getPathAcctoYear("/login")} state={{ from: location }}  />;
  }

  return children;
};

export default ProtectedRoute;
